import { LegalLayout } from "../components/LegalLayout";
import { usePageSEO } from "../hooks/usePageSEO";

export default function AGB() {
  usePageSEO({
    title: "AGB — Alphalane Trading Systems",
    description: "Allgemeine Geschäftsbedingungen von Alphalane Trading Systems / Moonshine Solutions GmbH.",
    canonical: "https://alphalane-tradingsystems.com/agb",
  });
  return (
    <LegalLayout title="Allgemeine Geschäftsbedingungen" lastUpdated="02.04.2024">
      <p>
        <strong>AGB der Moonshine Solutions GmbH</strong>
      </p>
      <p>
        Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die Nutzung unserer Angebote und unserer Plattformen, welche
        ggf. auf WhatsApp, Facebook, Instagram, YouTube, TikTok, LinkedIn, Twitter und Telegram zu erreichen sind. Daher beachten Sie
        bitte zusätzlich die rechtlichen Angaben (AGBs) der jeweiligen Plattform. Unter alphalane-tradingsystems.com ist
        lediglich der Zugang zu den Plattformen abrufbar. Die Community sowie unsere Angebote werden von uns, dem Community-Team
        der Moonshine Solutions GmbH, vertreten durch Herr Pascal Schwab, Venusweg 42 in 3185 Schmitten FR, angeboten. Durch die
        Nutzung der Seite, unserer Community und/oder den Kauf unserer ergänzenden Angebote erklären Sie sich mit diesen AGB
        einverstanden.
      </p>

      <h2>Hinweis unserer Seite</h2>
      <p>
        Wir teilen lediglich unsere Erfolge sowie Wissen zu unseren Konzepten und weiteren Dienstleistungen. Alle Investitionen
        und jegliche Projekte sind stets ein Risikoinvestment. Wir als Community übernehmen keinerlei Haftung für deine eigen
        getätigten Investments in Projekte bzw. Konzepte. Die Angebote durch die Moonshine Solutions GmbH dienen als unverbindliche
        Hilfestellung zu unseren Konzepten und Ideen. Wir bieten keine verbindliche Beratung zu deinen Investitionen und Konzepten,
        sondern teilen lediglich unsere persönliche Meinung.
      </p>

      <h2>Besondere Bedingungen für den Alphalane Trading-Service</h2>
      <p>
        Ergänzend zu den nachfolgenden allgemeinen Bestimmungen gelten für den vollautomatisierten Alphalane Trading-Service
        die folgenden besonderen Konditionen. Im Konfliktfall gehen die Bestimmungen dieses Abschnitts den allgemeinen
        Regelungen vor, soweit sie sich auf den Alphalane Trading-Service beziehen.
      </p>

      <h3>A.1 Leistungsumfang</h3>
      <p>
        Alphalane stellt dem Kunden ein vollautomatisiertes, regelbasiertes Trading-System zur Verfügung, das im Auftrag des
        Kunden Trades auf einem auf den Namen des Kunden lautenden Handelskonto bei einem Partner-Broker ausführt. Der Kunde
        behält jederzeit die volle Kontrolle über sein Konto und sein Kapital. Alphalane hat ausschliesslich Zugriff auf die
        Handelsausführung — <strong>nicht</strong> auf Ein- oder Auszahlungen.
      </p>
      <p>
        Das System ist 24/5 (Montag bis Freitag) im Markt aktiv und wird zusätzlich manuell durch das Alphalane-Team überwacht.
        Gehandelt wird diversifiziert in Futures-Märkten (u.&nbsp;a. Rohstoffe und Aktien) sowie ergänzend Forex.
      </p>

      <h3>A.2 Mindesteinlage</h3>
      <p>
        Die Mindesteinlage beträgt <strong>2'000&nbsp;USD</strong> auf dem persönlichen Brokerkonto des Kunden. Der Kunde
        bestimmt die Investmentgrösse selbst und sollte nur Kapital einsetzen, dessen Verlust im schlimmsten Fall für ihn
        tragbar wäre.
      </p>

      <h3>A.3 Vergütung — Performance Fee</h3>
      <p>
        Die Vergütung für den Alphalane Trading-Service erfolgt ausschliesslich performance-basiert in Höhe von
        <strong> 40&nbsp;% auf erzielte Nettogewinne</strong>. In Verlustmonaten fallen <strong>keine Gebühren</strong> an.
        Es gibt keine Fixkosten und keine versteckten Kosten. Die Performance-Fee wird wochenweise auf Basis der erzielten
        Gewinne berechnet und über das persönliche Dashboard transparent ausgewiesen.
      </p>

      <h3>A.4 Konto-Inhaberschaft &amp; Sicherheit</h3>
      <p>
        Das Handelskonto lautet <strong>ausschliesslich auf den Namen des Kunden</strong> und wird bei einem regulierten
        Partner-Broker geführt. Der Kunde hat zu jeder Zeit vollen Zugriff auf sein Konto sowie alle Kontobewegungen.
        Alphalane besitzt keine Zugriffs- oder Verfügungsrechte über das eingezahlte Kapital.
      </p>

      <h3>A.5 Risikomanagement</h3>
      <p>
        Alphalane setzt ein automatisiertes, regelbasiertes Risikomanagement ein. Wenn der wöchentliche Drawdown
        den Grenzwert überschreitet, wird das System automatisch pausiert und muss durch das Alphalane-Team
        manuell wieder aktiviert werden. Trotz dieser Massnahmen besteht jederzeit das Risiko von Verlusten
        bis hin zum Totalverlust des eingesetzten Kapitals.
      </p>

      <h3>A.6 Auszahlungen</h3>
      <p>
        Auszahlungen können vom Kunden jederzeit veranlasst werden und werden innerhalb einer <strong>Wochenfrist</strong>
        verarbeitet. Da das Kapital auf dem Konto des Kunden liegt, erfolgt die Auszahlung direkt durch den Broker an
        den Kunden gemäss dessen Auszahlungsanweisungen.
      </p>

      <h3>A.7 Laufzeit, Pausierung &amp; Kündigung</h3>
      <p>
        Es besteht <strong>keine Mindestlaufzeit</strong>. Der Service kann durch den Kunden jederzeit
        <strong> pausiert</strong> oder mit einer Frist von <strong>einer Woche</strong> beendet werden. Die Mitteilung
        erfolgt schriftlich per E-Mail an die im Impressum angegebene Adresse.
      </p>

      <h3>A.8 Keine garantierten Renditen</h3>
      <p>
        Alphalane gibt <strong>keine Garantie</strong> für bestimmte Renditen ab. Die historische Performance ist kein
        verlässlicher Indikator für zukünftige Ergebnisse. Das Team strebt eine monatliche Rendite von 5 – 20&nbsp;% an,
        die tatsächliche Performance hängt jedoch von den Marktbedingungen ab.
      </p>

      <h3>A.9 Keine Anlageberatung</h3>
      <p>
        Der Alphalane Trading-Service stellt <strong>keine Anlage-, Rechts- oder Steuerberatung</strong> dar.
        Investitionsentscheidungen trifft der Kunde stets eigenverantwortlich und auf eigenes Risiko. Wir empfehlen, bei
        finanziellen Entscheidungen unabhängige professionelle Beratung einzuholen.
      </p>

      <h3>A.10 Transparenz &amp; Reporting</h3>
      <p>
        Der Kunde hat über sein persönliches Dashboard <strong>Echtzeit-Einblick</strong> in alle Trades, Performance-Daten
        sowie verrechnete Performance-Fees. Wöchentliche Abrechnungen werden im Dashboard hinterlegt; Gewinne können
        ausbezahlt oder reinvestiert werden.
      </p>

      <h3>A.11 Haftungsbeschränkung Trading-Service</h3>
      <p>
        Die Haftung der Moonshine Solutions GmbH für Schäden im Zusammenhang mit dem Alphalane Trading-Service ist auf
        Vorsatz und grobe Fahrlässigkeit beschränkt, soweit gesetzlich zulässig. Eine Haftung für entgangene Gewinne,
        indirekte Schäden oder Marktverluste, die nicht auf einer schuldhaften Pflichtverletzung beruhen, ist
        ausgeschlossen.
      </p>

      <h2>1. Geltungsbereich</h2>
      <p>
        Für alle Bestellungen über unsere Webseite gelten die nachfolgenden Allgemeinen Geschäftsbedingungen (AGB). Das Angebot
        auf dieser Webseite richtet sich ausschliesslich an Konsumentinnen und Konsumenten mit Wohnsitz in der Schweiz
        (nachfolgend „Kunde").
      </p>
      <p>
        Als Konsumentin oder Konsument wird eine natürliche Person bezeichnet, welche mit der Moonshine Solutions GmbH
        geschäftliche Beziehungen pflegt, die weder ihrer gewerblichen noch ihrer selbständigen beruflichen Tätigkeit zugeordnet
        werden kann. Bestellungen in nicht haushaltsüblichen Mengen können ohne Begründung abgelehnt werden.
      </p>
      <p>
        Moonshine Solutions GmbH behält sich das Recht vor, diese AGB jederzeit zu ändern. Massgebend ist jeweils die zum
        Zeitpunkt der Bestellung geltende Version dieser AGB, welche für diese Bestellung nicht einseitig geändert werden können.
        Entgegenstehende oder von diesen AGB abweichende Bedingungen der Kundschaft werden nicht anerkannt.
      </p>
      <p>Der Betreiber dieses Internetauftritts ist die Moonshine Solutions GmbH.</p>

      <h2>2. Informationen</h2>
      <p>
        Die Webseite alphalane-tradingsystems.com beinhaltet Informationen über Produkte und Dienstleistungen. Preis- und
        Sortimentsänderungen sowie technische Änderungen bleiben vorbehalten. Alle Angaben (Produktbeschreibungen, Abbildungen,
        Illustrationen, Filme, Masse, Gewichte, technische Spezifikationen, Zubehörbeziehungen und sonstige Angaben) dienen der
        Illustration und sind als Näherungswerte zu verstehen und sind unverbindlich. Sie stellen insbesondere keine Zusicherung
        von Eigenschaften oder Garantien dar, ausser es ist explizit anders vermerkt. Moonshine Solutions GmbH bemüht sich,
        sämtliche Angaben und Informationen auf dieser Webseite korrekt, vollständig, aktuell und übersichtlich bereitzustellen,
        jedoch kann Moonshine Solutions GmbH weder ausdrücklich noch stillschweigend dafür Gewähr leisten.
      </p>
      <p>Sämtliche Angebote auf dieser Webseite gelten als freibleibend und sind nicht als verbindliche Offerte zu verstehen.</p>
      <p>
        Moonshine Solutions GmbH kann keine Garantie abgeben, dass die aufgeführten Produkte zum Zeitpunkt der Bestellung
        verfügbar sind. Daher sind alle Angaben zu Verfügbarkeit und Lieferzeiten ohne Gewähr und können sich jederzeit und ohne
        Ankündigung ändern.
      </p>

      <h2>3. Preise</h2>
      <p>
        Die angegebenen Verkaufspreise stellen Endpreise dar und beinhalten, wenn nicht anders vermerkt, die gesetzliche
        Mehrwertsteuer und allfällige weitere gesetzliche Abgaben. Die Preise verstehen sich rein netto in Schweizer Franken (CHF).
      </p>
      <p>
        Allfällige Versandkosten werden, wo nicht anders vorgesehen, zusätzlich verrechnet und sind durch den Kunden zu bezahlen.
        Versandkosten werden im Bestellprozess separat ausgewiesen.
      </p>
      <p>
        Technische Änderungen, Irrtümer und Druckfehler bleiben vorbehalten, insbesondere kann Moonshine Solutions GmbH
        Preisänderungen jederzeit und ohne Vorankündigungen vornehmen. In den Verkaufspreisen sind keine Beratungs- und
        Supportdienstleistungen inbegriffen.
      </p>

      <h2>4. Vertragsabschluss</h2>
      <p>Die Produkte und Preise auf dieser Webseite gelten als unverbindliche Angebote.</p>
      <p>
        Mit der Bestellung über diese Webseite inklusive der Annahme dieser AGB gibt der Kunde ein rechtlich verbindliches Angebot
        zum Vertragsabschluss ab. Moonshine Solutions GmbH versendet daraufhin eine automatische Bestelleingangsbestätigung per
        E-Mail, welche bestätigt, dass das Angebot des Kunden bei Moonshine Solutions GmbH eingegangen ist. Getätigte Bestellungen
        sind für den Kunden verbindlich. Wo nicht anders vermerkt, gibt es kein Rückgabe- bzw. Rücktrittsrecht.
      </p>
      <p>
        Der Vertrag kommt zustande, sobald Moonshine Solutions GmbH eine Annahmeerklärung per E-Mail versendet, worin der Versand
        der bestellten Produkte oder Dienstleistungen bestätigt wird.
      </p>
      <p>
        Bestellungen werden erst nach vollständigem Zahlungseingang (Ausnahme: Lieferung gegen Rechnung) und sofern die Waren
        verfügbar sind, ausgeliefert. Ergibt sich, dass die bestellten Waren nicht oder nicht vollständig geliefert werden können,
        ist Moonshine Solutions GmbH berechtigt, die Bestellung nicht oder nur teilweise anzunehmen bzw. auszuführen.
      </p>
      <p>Dem Kunden stehen die im Bestellvorgang angegebenen Zahlungsmöglichkeiten zur Verfügung.</p>
      <p>
        Moonshine Solutions GmbH behält sich das Recht vor, Kunden ohne Angabe von Gründen von einzelnen Zahlungsmöglichkeiten
        auszuschliessen oder auf Vorauskasse zu bestehen.
      </p>
      <p>
        Moonshine Solutions GmbH kann bei Zahlungsverzug des Kunden Verzugszinsen von 5&nbsp;% pro Jahr sowie eine Mahngebühr von
        maximal CHF&nbsp;20.– pro Mahnung erheben.
      </p>
      <p>
        Die dem Kunden gelieferten Produkte bleiben bis zur vollständigen Bezahlung im Eigentum von Moonshine Solutions GmbH.
      </p>

      <h2>5. Lieferung, Prüfpflicht, Mängelrüge und Rücksendung</h2>
      <p>Die Lieferungen werden per Post oder Kurierdienst an die vom Kunden in der Bestellung angegebene Adresse versandt.</p>
      <p>
        Moonshine Solutions GmbH ist bemüht, möglichst kurze Lieferfristen einzuhalten. Allfällig in der Bestellbestätigung
        angegebene Lieferfristen sind jedoch unverbindlich. Moonshine Solutions GmbH ist zu Teillieferungen berechtigt. Die
        Versandkosten werden in diesem Fall dem Kunden nur einmal berechnet.
      </p>
      <p>
        Der Versand der Rechnung, soweit Lieferung gegen Rechnung angeboten wird, erfolgt nach Wahl von Moonshine Solutions GmbH
        per E-Mail oder auf dem Postweg.
      </p>
      <p>
        Ist die Lieferung nicht zustellbar oder verweigert der Kunde die Annahme der Lieferung, kann Moonshine Solutions GmbH den
        Vertrag nach einer Mitteilung per E-Mail an den Kunden und unter Einhalten einer angemessenen Nachfrist auflösen sowie
        die Kosten für die Umtriebe in Rechnung stellen.
      </p>
      <p>
        Der Kunde ist verpflichtet, die gelieferten Waren sofort nach Eingang der Lieferung zu prüfen und allfällige Mängel,
        für die Moonshine Solutions GmbH Gewähr leistet, unverzüglich schriftlich per Brief oder E-Mail an die Adresse im
        Impressum anzuzeigen.
      </p>
      <p>
        Rücksendungen an Moonshine Solutions GmbH erfolgen auf Rechnung und Gefahr des Kunden. Der Kunde hat die Waren
        originalverpackt, komplett mit allem Zubehör und zusammen mit dem Lieferschein und einer ausführlichen Beschreibung der
        Mängel an die von Moonshine Solutions GmbH angegebene Rücksendeadresse zu schicken.
      </p>
      <p>
        Ergibt sich bei der Prüfung durch Moonshine Solutions GmbH, dass die Waren keine feststellbaren Mängel aufweisen oder
        diese nicht unter die Garantie des Herstellers fallen, kann Moonshine Solutions GmbH die Umtriebe, die Rücksendung oder
        die allfällige Entsorgung dem Kunden in Rechnung stellen.
      </p>

      <h2>6. Widerrufsrecht</h2>
      <p>
        Dem Kunden wird während 10 Kalendertagen nach Erhalt der Ware ein Widerrufsrecht gewährt. Die Frist gilt als eingehalten,
        wenn der Kunde den schriftlichen Widerruf per E-Mail oder Brief (Adresse gemäss Impressum) innerhalb der Frist an
        Moonshine Solutions GmbH abschickt. Der Widerruf bedarf keiner Begründung.
      </p>
      <p>
        Die Ausübung des Widerrufsrechts führt zu einer Rückabwicklung des Vertrages. Der Kunde muss die Waren innert
        10 Kalendertagen originalverpackt, komplett mit allem Zubehör und zusammen mit dem Lieferschein an die von Moonshine
        Solutions GmbH angegebene Rücksendeadresse zurücksenden. Rücksendungen erfolgen auf Rechnung und Gefahr des Kunden.
        Eine allenfalls bereits geleistete Zahlung wird innerhalb von 20 Kalendertagen an den Kunden zurückerstattet, sofern
        Moonshine Solutions GmbH die Ware bereits zurückerhalten hat oder der Kunde einen Versandnachweis erbringen kann.
      </p>
      <p>
        Moonshine Solutions GmbH behält sich vor, für Beschädigungen, übermässige Abnutzung oder Wertverlust aufgrund
        unsachgemässen Umgangs eine angemessene Entschädigung zu verlangen und die Wertminderung vom bereits bezahlten
        Kaufpreis abzuziehen oder dem Kunden in Rechnung zu stellen.
      </p>
      <p>In folgenden Fällen wird kein Widerrufsrecht gewährt:</p>
      <ul>
        <li>(i) Wenn der Vertrag ein Zufallselement hat, namentlich weil der Preis Schwankungen unterliegt, auf die der Anbieter keinen Einfluss hat;</li>
        <li>(ii) Wenn der Vertrag eine bewegliche Sache zum Gegenstand hat, die aufgrund ihrer Beschaffenheit nicht für eine Rücksendung geeignet ist oder schnell verderben kann;</li>
        <li>(iii) Wenn der Vertrag eine bewegliche Sache zum Gegenstand hat, die nach Vorgaben des Kunden angefertigt wird oder eindeutig auf persönliche Bedürfnisse zugeschnitten ist;</li>
        <li>(iv) Wenn der Vertrag digitale Inhalte zum Gegenstand hat und diese Inhalte nicht auf einem festen Datenträger zur Verfügung gestellt werden oder wenn der Vertrag von beiden Vertragsparteien sofort vollständig zu erfüllen ist;</li>
        <li>(v) Wenn der Vertrag eine Dienstleistung zum Gegenstand hat und der Vertrag vom Anbieter mit der vorgängigen ausdrücklichen Zustimmung des Kunden vollständig zu erfüllen ist, bevor die Widerrufsfrist abgelaufen ist;</li>
        <li>(vi) In den Bereichen Unterbringung, Beförderung, Lieferung von Speisen und Getränken sowie Freizeitgestaltung, wenn sich der Anbieter bei Vertragsabschluss verpflichtet, die Dienstleistungen zu einem bestimmten Zeitpunkt oder innerhalb eines genau angegebenen Zeitraums zu erbringen.</li>
      </ul>

      <h2>7. Gewährleistung</h2>
      <p>
        Moonshine Solutions GmbH bemüht sich, Waren in einwandfreier Qualität zu liefern. Bei rechtzeitig gerügten Mängeln
        übernimmt Moonshine Solutions GmbH während der gesetzlichen Gewährleistungsfrist von in der Regel zwei Jahren seit dem
        Lieferdatum die Gewährleistung für Mängelfreiheit und Funktionsfähigkeit des vom Kunden erworbenen Gegenstandes. Es liegt
        im Ermessen von Moonshine Solutions GmbH, die Gewährleistung durch kostenlose Reparatur, gleichwertigen Ersatz oder durch
        Rückerstattung des Kaufpreises zu erbringen. Weitere Gewährleistungsrechte sind ausgeschlossen.
      </p>
      <p>
        Von der Gewährleistung werden die normale Abnützung sowie die Folgen unsachgemässer Behandlung oder Beschädigung durch
        den Kunden oder Drittpersonen sowie Mängel, die auf äussere Umstände zurückzuführen sind, nicht erfasst. Ebenso wird die
        Gewährleistung für Verbrauchs- und Verschleissteile (z.&nbsp;B. Batterien, Akkus, etc.) wegbedungen.
      </p>
      <p>
        Moonshine Solutions GmbH ist es nicht möglich, Zusicherungen oder Garantien für die Aktualität, Vollständigkeit und
        Korrektheit der Daten sowie für die ständige oder ungestörte Verfügbarkeit der Webseite, deren Funktionalitäten,
        integrierten Hyperlinks und weiteren Inhalten abzugeben. Insbesondere wird weder zugesichert noch garantiert, dass durch
        die Nutzung der Webseite keine Rechte von Dritten verletzt werden, die nicht im Besitz von Moonshine Solutions GmbH sind.
      </p>

      <h2>8. Haftung</h2>
      <p>
        Moonshine Solutions GmbH schliesst jede Haftung, unabhängig von ihrem Rechtsgrund, sowie Schadenersatzansprüche gegen
        Moonshine Solutions GmbH und gegen allfällige Hilfspersonen und Erfüllungsgehilfen aus. Moonshine Solutions GmbH haftet
        insbesondere nicht für indirekte Schäden und Mangelfolgeschäden, entgangenen Gewinn oder sonstige Personen-, Sach- und
        reine Vermögensschäden des Kunden. Vorbehalten bleibt eine weitergehende zwingende gesetzliche Haftung, beispielsweise
        für grobe Fahrlässigkeit oder rechtswidrige Absicht.
      </p>
      <p>
        Moonshine Solutions GmbH benutzt Hyperlinks lediglich für den vereinfachten Zugang des Kunden zu anderen Webangeboten.
        Moonshine Solutions GmbH kann weder den Inhalt dieser Webangebote im Einzelnen kennen noch die Haftung oder sonstige
        Verantwortung für die Inhalte dieser Webseiten übernehmen.
      </p>

      <h2>9. Datenschutz</h2>
      <p>
        Moonshine Solutions GmbH darf die im Rahmen des Vertragsschlusses aufgenommenen Daten zur Erfüllung der Verpflichtungen
        aus dem Kaufvertrag verarbeiten und nutzen sowie zu Marketingzwecken verwenden. Die zur Leistungserfüllung notwendigen
        Daten können auch an beauftragte Dienstleistungspartner (Logistikpartner) oder sonstige Dritte weitergegeben werden.
      </p>
      <p>
        Die Datenschutzbestimmungen sind im Einzelnen unter <a href="/datenschutz">Datenschutz</a> aufrufbar.
      </p>

      <h2>10. Teilungültigkeit</h2>
      <p>
        Sollten sich einzelne Bestimmungen dieser AGB als unwirksam oder undurchführbar erweisen oder unwirksam oder
        undurchführbar werden, so bleibt dadurch die Wirksamkeit der übrigen Bestimmungen unberührt.
      </p>

      <h2>11. Weitere Bestimmungen</h2>
      <p>
        Moonshine Solutions GmbH behält sich ausdrücklich vor, die vorliegenden AGB jederzeit zu ändern und ohne Ankündigung
        in Kraft zu setzen.
      </p>
      <p>
        Im Falle von Streitigkeiten kommt <strong>ausschliesslich materielles Schweizer Recht</strong> unter Ausschluss von
        kollisionsrechtlichen Normen zur Anwendung. Das UN-Kaufrecht (CISG, Wiener Kaufrecht) wird explizit ausgeschlossen.
      </p>
      <p>
        <strong>Gerichtsstand ist Schmitten FR (Schweiz), Sitz von Moonshine Solutions GmbH, oder der Wohnsitz der Konsumentin
        oder des Konsumenten.</strong>
      </p>

      <h2>12. Kontakt</h2>
      <p>
        Bei Fragen zu diesen AGB melden Sie sich bitte über das <a href="/impressum">Impressum</a>.
      </p>

      <p className="!mt-12 !text-sm !text-slate-500">Stand: 02.04.2024 — Moonshine Solutions GmbH</p>
    </LegalLayout>
  );
}
